import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

const CommonAlertDialog = ({ open, onClose, type = "success", message }) => {
  const isSuccess = type === "success";

  const handleClose = () => {
    onClose();
    if (isSuccess) {
      setTimeout(() => {
        window.location.reload();
      }, 300);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth={false} // disable default sizing
      PaperProps={{
        sx: {
          width: "360px",          // ⬅ reduced width
          borderRadius: "16px",
          textAlign: "center",
          px: 2,
          py: 3,
        },
      }}
    >
      <DialogContent>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          gap={2}
        >
          {isSuccess ? (
            <CheckCircleOutlineIcon sx={{ fontSize: 70, color: "#28a745" }} />
          ) : (
            <HighlightOffIcon sx={{ fontSize: 70, color: "#dc3545" }} />
          )}
          <Typography
            variant="subtitle1"
            fontWeight={600}
            color={isSuccess ? "#28a745" : "#dc3545"}
            sx={{ wordBreak: "break-word" }}
          >
            {message}
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
        <Button
          onClick={handleClose}
          variant="contained"
          sx={{
            px: 3,
            borderRadius: "10px",
            backgroundColor: isSuccess ? "#28a745" : "#dc3545",
            "&:hover": {
              backgroundColor: isSuccess ? "#218838" : "#c82333",
            },
          }}
        >
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CommonAlertDialog;
